import { useUser } from 'modules/user'
import { RegisterTokenContainer as RegisterTokenContainerSalesperson } from 'modules/salesperson'
import { RegisterTokenContainer as RegisterTokenContainerMerchant } from 'modules/merchant'

export function RegisterTokenContainer() {
  const { user } = useUser()

  return user.data.currentCompany.is_buyer ? (
    <RegisterTokenContainerMerchant />
  ) : (
    <RegisterTokenContainerSalesperson />
  )
}
